module.exports = __webpack_public_path__ + "img/P59-en.06219ff9.png";